import { Injectable, Optional } from '@angular/core';
import { EnvironmentConfig } from './config';
import { getScript } from '../utils/getScript';

declare const grecaptcha: any;

@Injectable({ providedIn: 'root' })
export class RecaptchaService {

    constructor(@Optional() private config: EnvironmentConfig) {
        if (typeof grecaptcha === 'undefined') {
            getScript('https://www.google.com/recaptcha/api.js?render=' + this.config.RECAPTCHA_SITE_KEY)
        }
    }

    validate(action: string, data: any): Promise<any> {
        return new Promise(resolve => {
            grecaptcha.ready(() => {
                grecaptcha.execute(this.config.RECAPTCHA_SITE_KEY, { action }).then((token: string) => {
                    // Add your logic to submit to your backend server here
                    data.RECAPTCHA_TOKEN = token;
                    return resolve(data)
                })
            })
        })
    }
}
